import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { LazyLoadEvent } from 'primeng/primeng';
import { PositionService} from '../services/position.service';
import { DeviceService } from '../services/device.service';
import { UserService } from '../services/user.service';
import { MainService} from '../services/main.service';
import { GeofenceService} from '../services/geofence.service';
import { InterestPointService} from '../services/interest-point.service';
import { Message } from 'primeng/primeng';
import { Table } from 'primeng/components/table/table';
import  *  as $ from 'jquery';

declare var MapLabel: any;

@Component({
  selector: 'app-position-history',
  templateUrl: './position-history.component.html',
  styleUrls: ['./position-history.component.css']
})
export class PositionHistoryComponent implements OnInit {

  showStops: boolean=false;
  showAlarms: boolean=false;
  showInterestPoints: boolean=false;
  positionSelected : any;
  positions : any [];
  devices: SelectItem[];
  idDevice: String;
  initialDate: Date;
  finalDate: Date;
  options: any;
  overlays: any[];
  //markersStopped : any[];
  //markersAlarm : any[];
  map: google.maps.Map;
  marker: google.maps.Marker;
  infoWindow:google.maps.InfoWindow;
  dateOptions: SelectItem[];
  dateOption: any;
  disabledInitialDate: boolean;
  disabledFinalDate: boolean;
  disabledFirst: boolean;
  disabledBack: boolean;
  disabledPlay: boolean;
  disabledPause: boolean;
  disabledNext: boolean;
  disabledLast: boolean;
  msgs: Message[] = [];
  blockedDocument: boolean = false;
  indice: number;
  timerId:any;
  loading: boolean;
  totalRecords:number;
  distanceTraveled:number;
  labels :any[];
  xmlDocument: XMLDocument;
  fileName:String;

  @ViewChild('dt') table: Table;

  constructor(private positionService:PositionService,private deviceService : DeviceService,private interestPointService:InterestPointService,private userService: UserService,private geofenceService :GeofenceService,private mainService:MainService) { }

  ngOnInit() {
    this.dateOptions = [
      {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
      {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
      {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
      {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
    ];

    this.devices = [];
    this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.devices.forEach(item => {
        this.devices.push({label: item.name, value: item.idDevice});
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
    this.disabledFirst= true;
    this.disabledBack=true;
    this.disabledPlay=true;
    this.disabledPause=true;
    this.disabledNext=true;
    this.disabledLast=true;
    this.dateOption = 'T';
    this.changeDate();
    this.options = {
      zoom: 14
    };
  }

  changeDate(){
    this.disabledInitialDate = true;
    this.disabledFinalDate = true;
    if(this.dateOption == 'T'){
      this.initialDate = new Date();
      this.finalDate = new Date();
      this.initialDate.setHours(0,0,0);
      this.finalDate.setHours(23,59,59);
    }else if(this.dateOption == 'Y'){
      this.initialDate = new Date();
      this.finalDate = new Date();
      this.initialDate.setDate(this.initialDate.getDate() - 1);
      this.initialDate.setHours(0,0,0);
      this.finalDate.setDate(this.finalDate.getDate() - 1);
      this.finalDate.setHours(23,59,59);
    }else if(this.dateOption == '7'){
      this.initialDate = new Date();
      this.finalDate = new Date();
      this.initialDate.setDate(this.initialDate.getDate() - 6);
      this.initialDate.setHours(0,0,0);
      this.finalDate.setHours(23,59,59);
    }else{
      this.disabledInitialDate = false;
      this.disabledFinalDate = false;
    }
  }

  setMap(event) {
    this.map = event.map;
  }

  diferenciaEntreFechasEnDias(a:Date, b:Date):number{
    return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
  }

  drawTravel(){
    this.overlays = [];
    let recorrido = new google.maps.Polyline({
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2
    });
    this.overlays.push(recorrido);
    let positionOld : any = null;
    this.distanceTraveled=0;
    this.positions.forEach(item => {
      this.distanceTraveled = this.distanceTraveled + item.distanceTraveled;
      let latLng = new google.maps.LatLng(item.latitude, item.longitude);
      recorrido.getPath().push(latLng);
      if(positionOld!=null){
        let distance = this.getDistanceInMeters(item,positionOld)
        if(distance > 400){
          this.addMarkerRecorrido(item);
        }
      }
      positionOld = item;
    });
    this.distanceTraveled = +(this.distanceTraveled /1000).toFixed(2);
    this.addMarker(this.positions[0]);
  }

  drawInterestPoints(){
    this.interestPointService.findByUser(this.userService.userLoged.idUser).then(data =>{
      let response: any = data;
      response.interestPoints.forEach(item => {
        this.addMarkerInterestPoint(item);
      });
      this.interestPointService.findPublic().then(data =>{
        let response: any = data;
        response.interestPoints.forEach(item => {
          this.addMarkerInterestPoint(item);
        });

      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
  }

  drawParked(initialDate,finalDate){
    this.positionService.findStoppedTimes(this.idDevice,initialDate,finalDate,2,"ignition").then(data => {
      let response: any = data;
      response.positions.forEach(item => {
        //if(item.time >= 2*1000*60){ //Tiempos paradas mayor a 2 min
          this.addMarkerStopped(item);
        //}
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
  }

  drawAlarm(initialDate,finalDate){
    this.positionService.findAlarm(this.idDevice,initialDate,finalDate,null).then(data => {
      let response: any = data;
      response.positions.forEach(item => {
        this.addMarkerAlarm(item);
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
  }

  getDistanceInMeters(positionIni:any,positionFin:any) : number{
    let R = 6371;
    let dLat = (positionFin.latitude-positionIni.latitude) * (Math.PI/180);
    let dLon = (positionFin.longitude-positionIni.longitude) * (Math.PI/180);
    let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(positionIni.latitude * (Math.PI/180)) * Math.cos(positionFin.latitude * (Math.PI/180)) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    let d = R * c;
    return d*1000;
  }

  validar(){
    if(this.diferenciaEntreFechasEnDias(this.initialDate,this.finalDate) > 7){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los 7 dias"}];
      return false;
    }
    if(this.initialDate >= this.finalDate){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"La fecha final debe ser superior a la fecha inicial"}];
      return false;
    }
    return true;
  }

  buscar(){
    if(this.table){
      this.table.first=1;
    }

    if(!this.validar()){
      return;
    }
    this.blockedDocument = true;
    //this.markersStopped = [];
    this.positionService.countFindBetweenDates(this.idDevice,this.initialDate,this.finalDate).then(data => {
      let response: any = data;
      this.totalRecords = response.count;
      if(this.totalRecords > 0 ){
        this.loadPositions(0,800);
      }else{
        this.msgs = [{severity:'info', summary:'INFO', detail:"No se encontraron registros"}];
        this.blockedDocument = false;
        this.loading = false;
      }
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
      this.loading = false;
    });
  }

  removeGeofences(){
    for(let i in this.labels) {
      this.labels[i].setMap(null);
    }
    this.labels = [];
    let newArray = [];
    for(let i in this.overlays) {
      if(this.overlays[i] instanceof google.maps.Polyline && this.overlays[i].strokeColor == "#1976D2"){
        continue;
      }else{
        if(this.overlays[i] instanceof google.maps.Circle  || this.overlays[i] instanceof google.maps.Polygon){
          continue;
        }else{
          newArray.push(this.overlays[i]);
        }
      }
    }
    this.overlays = newArray;
  }

  drawGeofences(idDevice:String){
    this.removeGeofences();
    this.geofenceService.findByDevice(idDevice).then(data => {
      let response: any = data;
      response.geofences.forEach(geofence => {
        if(geofence.type == "C"){
          let latlng = new google.maps.LatLng(geofence.circle.centerLatitude,geofence.circle.centerLongitude);

          let circle = new google.maps.Circle({center: latlng,fillColor: '#1976D2',fillOpacity: 0.35,strokeWeight: 1,radius: geofence.circle.radius});
          this.overlays.push(circle);
          let mapLabel = new MapLabel({text: geofence.name,position: latlng,map: this.map,fontSize: 20,align: 'center'});
          this.labels.push(mapLabel);
        }else if(geofence.type == "L"){
          let line = new google.maps.Polyline({
            geodesic: true,
            strokeColor: '#1976D2',
            strokeOpacity: 0.35,
            strokeWeight: geofence.line.distance});
            let latlng = null;
            geofence.line.coordinates.forEach(item => {
              latlng = new google.maps.LatLng(item.latitude, item.longitude);
              line.getPath().push(latlng);
            });
            this.overlays.push(line);
            let mapLabel = new MapLabel({
              text: "   "+geofence.name,
              position: latlng,
              map: this.map,
              fontSize: 20,
              align: 'left'
            });
            this.labels.push(mapLabel);
          }else if(geofence.type == "P"){
            let polygon = new google.maps.Polygon({
              strokeColor: '#1976D2',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: '#1976D2',
              fillOpacity: 0.35
            });
            let latlng = null;
            geofence.polygon.coordinates.forEach(item => {
              latlng = new google.maps.LatLng(item.latitude, item.longitude);
              polygon.getPath().push(latlng);
            });
            this.overlays.push(polygon);
            let mapLabel = new MapLabel({
              text: geofence.name,
              position: latlng,
              map: this.map,
              fontSize: 20,
              align: 'center'
            });
            this.labels.push(mapLabel);
          }
        });
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
    }

    removeDuplicates(originalArray, prop) {
      return originalArray.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    }


    loadPositions(first: number, rows:number){
      this.blockedDocument = true;
      this.loading = true;
      this.positions = [];

      this.positionService.findBetweenDates(this.idDevice,this.initialDate,this.finalDate,first,rows).then(data => {
        let response: any = data;
        let latitudeOld = null;
        let longitudeOld = null;

        if(response.status != "OK"){
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          this.blockedDocument = false;
          this.loading = false;
          return;
        }
        response.positions.forEach(item => {
          if((latitudeOld == null || item.latitude != latitudeOld ) && (longitudeOld == null || item.longitude != longitudeOld ) ){
            item.group = [];
            this.positions.push(item);
          }else{
            this.positions[this.positions.length-1].group.push(item);
          }
          latitudeOld = item.latitude;
          longitudeOld = item.longitude;
        });
        this.positions = this.removeDuplicates(this.positions,"idPosition");
        this.drawTravel();
        this.drawGeofences(this.idDevice);
        let intialDatePagination = this.mainService.convertStrintToDate(response.positions[0].deviceTime);
        let finalDatePagination = this.mainService.convertStrintToDate(response.positions[response.positions.length-1].deviceTime);
        if(this.showStops){
          this.drawParked(intialDatePagination,finalDatePagination);
        }
        if(this.showAlarms){
          this.drawAlarm(intialDatePagination,finalDatePagination);
        }
        if(this.showInterestPoints){
          this.drawInterestPoints();
        }
        this.blockedDocument = false;
        this.disabledPlay = false;
        this.goFirst();
        this.loading = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
        this.loading = false;
      });
      this.positionSelected = this.positions[0];
    }

    loadPositionsLazy(event: LazyLoadEvent) {
      this.loadPositions(event.first,event.rows);
    }

    goFirst(){
      this.goIndex(0,false);
    }

    goNext(){
      this.indice=this.indice+1;
      this.positionSelected = this.positions[this.indice];
      this.goIndex(this.indice,false)
      this.checkControls();
    }

    goBack(){
      this.indice = this.indice - 1;
      this.positionSelected = this.positions[this.indice];
      this.goIndex(this.indice,false);
      this.checkControls();
    }

    goLast(){
      this.goIndex(this.positions.length-1,false);
    }

    getContent(position: any){
      let alarm = position.extended.find(i => i.key == "alarm");

      let content = '<div id="iw-container">' +
      '<div class="iw-title" style="text-align:center;">'+position.nameDevice+'</div>' +
      '<div class="iw-content">' +
      '<div>'+
      '<label style="font-weight: bold;">ID: </label><label>'+position.idDevice+'</label>' +
      '</div>'+
      '<div>'+
      '<label style="font-weight: bold;">Fecha/Hora: </label><label>'+position.deviceTime+'</label>' +
      '</div>'+
      '<div>'+
      '<label style="font-weight: bold;">Velocidad: </label><label>'+position.speed.toFixed(2)+'</label>' +
      '</div>';

      if(alarm != undefined){
        content += alarm.value != undefined && alarm.value != '' ? '<label style="font-weight: bold; color: red;">Alarma: </label><label style="color: red;">'+alarm.value+'</label>':'';
      }
      //alarm !== undefined &&
      content += '</div></div>';
      return content;
    }

    getContentAlarm(position: any){
      return '<div id="iw-container">' +
      '<div class="iw-title" style="text-align:center;">'+position.nameDevice+'</div>' +
      '<div class="iw-content">' +
      '<div>'+
      '<label style="font-weight: bold;">Velocidad: </label><label>'+position.speed.toFixed(2)+'</label>' +
      '</div>'+
      '<div>'+
      '<label style="font-weight: bold;">Fecha/Hora: </label><label>'+position.deviceTime+'</label>' +
      '</div>'+
      '<div>'+
      '<label style="font-weight: bold;">Alarma: </label><label>'+position.alarmDescription+'</label>' +
      '</div>'+
      '</div>' +
      '</div>';
    }

    getContentPark(position: any){
      return '<div id="iw-container">' +
      '<div class="iw-title" style="text-align:center;">'+position.nameDevice+'</div>' +
      '<div class="iw-content">' +
      '<div>'+
      '<label style="font-weight: bold;">Tiempo Estacionado: </label><label>'+position.duration+'</label>' +
      '</div>'+
      '<div>'+
      '<label style="font-weight: bold;">Desde: </label><label>'+position.from+'</label>' +
      '</div>'+
      '<div>'+
      '<label style="font-weight: bold;">Hasta: </label><label>'+position.to+'</label>' +
      '</div>'+
      '</div>' +
      '</div>';
    }

    getContentInterestPoint(interestPoint: any){
      let content = '<div id="iw-container">' +
      '<div class="iw-title" style="text-align:center;">'+interestPoint.name+'</div>' +
      '<div class="iw-content">' +
      '<div>';
      if(interestPoint.description != undefined){
        content += '<label style="font-weight: bold;">Descripción: </label><label>'+interestPoint.description+'</label>';
      }else{
        content += '<label style="font-weight: bold;">Descripción: </label><label>Sin Descripción</label>';
      }
      content +='</div>'+
      '</div>'+
      '</div>';
      return content;
    }

    addMarkerInterestPoint(interestPoint: any){
      let latLng = new google.maps.LatLng(interestPoint.latitude, interestPoint.longitude);
      //this.map.setCenter(latLng);
      let infoWindow = new google.maps.InfoWindow({content: this.getContentInterestPoint(interestPoint),maxWidth: 350});

      let label = {text: interestPoint.name,color: 'black',fontSize: "12px",fontWeight: "bold"};
      let icon = {
        url: "assets/layout/images/markers/points/"+interestPoint.type+".png", // url
        scaledSize: new google.maps.Size(50, 50), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(25, 38), // anchor,
        labelOrigin: new google.maps.Point(interestPoint.name.length<8?interestPoint.name.length*4:interestPoint.name.length*2,0)
      };

      let marker = new google.maps.Marker({position: latLng ,icon:icon,label:label});
      marker.addListener('click', () => {
        infoWindow.open(this.map, marker);
      });

      google.maps.event.addListener(this.map, 'click', function(){
        infoWindow.close();
      });

      this.overlays.push(marker);

      google.maps.event.addListener(infoWindow, 'domready', function() {
        var iwOuter = $('.gm-style-iw');
        var iwBackground = iwOuter.prev();
        iwBackground.children(':nth-child(2)').css({'display' : 'none'});
        iwBackground.children(':nth-child(4)').css({'display' : 'none'});
        // Moves the infowindow 115px to the right.
        //iwOuter.parent().parent().css({left: '115px'});
        //iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

        var iwCloseBtn = iwOuter.next();
        //iwCloseBtn.css({opacity: '1', right: '78px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
        //iwCloseBtn.css({opacity: '1', right: '30px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
        iwCloseBtn.css({'display' : 'none'});

        iwCloseBtn.mouseout(function(){
          $(this).css({opacity: '1'});
        });
      });
    }

    addMarkerStopped(position: any){

      let latLng = new google.maps.LatLng(position.latitude, position.longitude);
      this.map.setCenter(latLng);

      this.infoWindow = new google.maps.InfoWindow({content: this.getContentPark(position)});

      let icon = {
        url: "assets/layout/images/markers/parada.png", // url
        scaledSize: new google.maps.Size(45, 45), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(22.5, 38) // anchor,
      };

      let marker = new google.maps.Marker({position: latLng ,icon:icon});
      //var marker = this.marker;
      var infowindow = this.infoWindow;
      marker.addListener('click', () => {
        infowindow.open(this.map, marker);
      });

      google.maps.event.addListener(this.map, 'click', function(){
        infowindow.close();
      });

      this.overlays.push(marker);

      google.maps.event.addListener(this.infoWindow, 'domready', function() {
        var iwOuter = $('.gm-style-iw');
        var iwBackground = iwOuter.prev();
        iwBackground.children(':nth-child(2)').css({'display' : 'none'});
        iwBackground.children(':nth-child(4)').css({'display' : 'none'});
        // Moves the infowindow 115px to the right.
        //  iwOuter.parent().parent().css({left: '115px'});
        //wBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

        var iwCloseBtn = iwOuter.next();
        //iwCloseBtn.css({opacity: '1', right: '30px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
        iwCloseBtn.css({'display' : 'none'});

        iwCloseBtn.mouseout(function(){
          $(this).css({opacity: '1'});
        });
      });
    }

    addMarkerAlarm(position: any){
      //let exist = false;
      //this.markersStopped.forEach(item => {
      //if(item.latitude == position.latitude && item.longitude == position.longitude){
      //let exist = true;
      //}
      //});
      //if(exist){
      //return;
      //}
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);
      this.map.setCenter(latLng);

      this.infoWindow = new google.maps.InfoWindow({content: this.getContentAlarm(position)});

      let icon = {
        url: "assets/layout/images/markers/alarm.png", // url
        scaledSize: new google.maps.Size(45, 45), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(22.5, 38) // anchor,
      };

      let marker = new google.maps.Marker({position: latLng ,icon:icon});
      //var marker = this.marker;
      var infowindow = this.infoWindow;
      marker.addListener('click', () => {
        infowindow.open(this.map, marker);
      });

      google.maps.event.addListener(this.map, 'click', function(){
        infowindow.close();
      });

      this.overlays.push(marker);

      google.maps.event.addListener(this.infoWindow, 'domready', function() {
        var iwOuter = $('.gm-style-iw');
        var iwBackground = iwOuter.prev();
        iwBackground.children(':nth-child(2)').css({'display' : 'none'});
        iwBackground.children(':nth-child(4)').css({'display' : 'none'});
        // Moves the infowindow 115px to the right.
        //  iwOuter.parent().parent().css({left: '115px'});
        //wBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

        var iwCloseBtn = iwOuter.next();
        //iwCloseBtn.css({opacity: '1', right: '30px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
        iwCloseBtn.css({'display' : 'none'});

        iwCloseBtn.mouseout(function(){
          $(this).css({opacity: '1'});
        });
      });
    }

    addMarkerRecorrido(position: any){
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);

      let infoWindow = new google.maps.InfoWindow({content: this.getContent(position)});
      //let label = {text: position.nameDevice,color: 'blue',fontSize: "12px",fontWeight: "bold"};
      var icon = {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        scale:1.3,
        fillColor: 'green',
        strokeColor: 'green',
        strokeWeight: 4,
        rotation:position.course,
        anchor: new google.maps.Point(-0.5, 0.5)
      };

      let marker = new google.maps.Marker({position: latLng,icon:icon});

      google.maps.event.addListener(marker,'click', function() {
        infoWindow.open(this.map, marker);
      });

      google.maps.event.addListener(this.map, 'click', function(){
        infoWindow.close();
      });

      this.overlays.push(marker);

      google.maps.event.addListener(infoWindow, 'domready', function() {
        var iwOuter = $('.gm-style-iw');
        var iwBackground = iwOuter.prev();
        iwBackground.children(':nth-child(2)').css({'display' : 'none'});
        iwBackground.children(':nth-child(4)').css({'display' : 'none'});
        // Moves the infowindow 115px to the right.
        //  iwOuter.parent().parent().css({left: '115px'});
        //  iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //    iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //  iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

        var iwCloseBtn = iwOuter.next();
        //iwCloseBtn.css({opacity: '1', right: '30px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
        iwCloseBtn.css({'display' : 'none'});

        iwCloseBtn.mouseout(function(){
          $(this).css({opacity: '1'});
        });
      });
    }

    addMarker(position: any){
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);
      this.map.setCenter(latLng);

      this.infoWindow = new google.maps.InfoWindow({content: this.getContent(position)});
      let label = {text: position.nameDevice,color: 'blue',fontSize: "12px",fontWeight: "bold"};

      let icon = {
        url: "assets/layout/images/markers/cars/car"+position.iconDevice+".png", // url
        scaledSize: new google.maps.Size(45, 45), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(22.5, 38), // anchor,
        labelOrigin: new google.maps.Point(position.nameDevice.length<10?position.nameDevice.length*5:position.nameDevice.length*2,0)
      };

      this.marker = new google.maps.Marker({position: latLng,label:label ,icon:icon,zIndex: 10});
      var marker = this.marker;
      var infowindow = this.infoWindow;
      this.marker.addListener('click', () => {
        infowindow.open(this.map, marker);
      });

      google.maps.event.addListener(this.map, 'click', function(){
        infowindow.close();
      });
      this.overlays.push(this.marker);

      google.maps.event.addListener(this.infoWindow, 'domready', function() {
        var iwOuter = $('.gm-style-iw');
        var iwBackground = iwOuter.prev();
        iwBackground.children(':nth-child(2)').css({'display' : 'none'});
        iwBackground.children(':nth-child(4)').css({'display' : 'none'});
        // Moves the infowindow 115px to the right.
        //  iwOuter.parent().parent().css({left: '115px'});
        //  iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //    iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //    iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

        var iwCloseBtn = iwOuter.next();
        //iwCloseBtn.css({opacity: '1', right: '30px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
        iwCloseBtn.css({'display' : 'none'});

        iwCloseBtn.mouseout(function(){
          $(this).css({opacity: '1'});
        });
      });

    }

    goIndex(index: number, showInfoWindow:boolean){
      this.positionSelected = this.positions[index];
      let latLng = new google.maps.LatLng(this.positionSelected.latitude, this.positionSelected.longitude);
      this.map.setCenter(latLng);
      this.marker.setPosition(latLng);
      this.indice = index;
      if(showInfoWindow){
        this.infoWindow.setContent(this.getContent(this.positionSelected));
        this.infoWindow.open(this.map, this.marker);
      }
      this.checkControls();
    }

    checkControls(){

      if(this.indice == 0){ // En el primer punto
        this.disabledFirst = true;
        this.disabledBack = true;
        this.disabledNext = false;
        this.disabledLast = false;
      } else if(this.indice == this.positions.length - 1){ // En el ultimo punto
        this.disabledFirst = false;
        this.disabledBack = false;
        this.disabledNext = true;
        this.disabledLast = true;
      }else{ //En los puntos del medio
        this.disabledFirst = false;
        this.disabledBack = false;
        this.disabledNext = false;
        this.disabledLast = false;
      }
    }

    onRowSelect(event) {
      this.positionSelected = event.data;
      this.indice = this.positions.indexOf(this.positionSelected);
      this.goIndex(this.indice,true);
    }

    play(){
      this.disabledFirst = true;
      this.disabledBack = true;
      this.disabledNext = true;
      this.disabledLast = true;
      this.disabledPlay = true;
      this.disabledPause = false;
      this.timerId = setInterval(() => {
        this.goNext();
      }, 500);
    }

    pause(){
      this.disabledPlay = false;
      this.disabledPause = true;
      clearInterval(this.timerId);
      this.checkControls();
    }

    exportKML(){
      this.fileName="Historial_";
      this.devices.forEach(item =>{
        if(item.value == this.idDevice){
          this.fileName = this.fileName+item.label+".kml";
        }
      });

      if(!this.validar()){
        return;
      }
      this.blockedDocument = true;
      this.loading = true;
      this.positions = [];
      this.positionService.findBetweenDates(this.idDevice,this.initialDate,this.finalDate,null,null).then(data => {
        let response: any = data;
        let latitudeOld = null;
        let longitudeOld = null;

        if(response.status != "OK"){
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          this.blockedDocument = false;
          this.loading = false;
          console.log(response.message);
          return;
        }
        response.positions.forEach(item => {
          if((latitudeOld == null || item.latitude != latitudeOld ) && (longitudeOld == null || item.longitude != longitudeOld ) ){
            item.group = [];
            this.positions.push(item);
          }else{
            this.positions[this.positions.length-1].group.push(item);
          }
          latitudeOld = item.latitude;
          longitudeOld = item.longitude;
        });
        this.positions = this.removeDuplicates(this.positions,"idPosition");

        this.blockedDocument = false;
        this.disabledPlay = false;
        this.loading = false;

        if(this.showStops){
          let parkedPositions = [];
          this.positionService.findStoppedTimes(this.idDevice,this.initialDate,this.finalDate,2,"ignition").then(data => {
            let response: any = data;
            response.positions.forEach((item,i) => {
              //if(item.time >= 2*1000*60){ //Tiempos paradas mayor a 2 min
                parkedPositions.push(item);
              //}
            });
            let kml = this.createKMLFile(this.positions,parkedPositions);
            this.download(this.fileName, kml);
          }).catch(err =>{
            console.log(err);
            this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
          });
        }else{
          let kml = this.createKMLFile(this.positions,[]);
          this.download(this.fileName, kml);
        }
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });

    }

    download(filename, xmlDocument): void {
      let element = document.createElement('a');
      element.setAttribute('href', 'data:application/vnd.google-earth.kml+xml;charset=utf-8,' + encodeURIComponent(xmlDocument));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }

    createKMLFile(positions :any[],parkedPositions :any[]): string {
      this.xmlDocument = document.implementation.createDocument("", "", null);
      let kmlNode = this.xmlDocument.createElement('kml');
      kmlNode.setAttribute('xmlns', 'http://www.opengis.net/kml/2.2');
      let documentNode = this.xmlDocument.createElement('Document');
      kmlNode.appendChild(documentNode);
      this.xmlDocument.appendChild(kmlNode);

      let styleParked = this.xmlDocument.createElement('Style');
      styleParked.setAttribute("id","parked");
      let iconParkedStyle = this.xmlDocument.createElement('IconStyle');

      let balloonParkedStyle = this.xmlDocument.createElement('BalloonStyle');
      let textParked = this.xmlDocument.createElement('text');
      textParked.innerHTML="<h2>$[nameDevice]</h2><br/><b>ID: </b>$[idDevice]<br/><b>Tiempo Estacionado: </b>$[duration]<br/><b>Desde: </b>$[from]<br/><b>Hasta: </b>$[to]<br/>";
      balloonParkedStyle.appendChild(textParked);
      styleParked.appendChild(balloonParkedStyle);

      let style = this.xmlDocument.createElement('Style');
      style.setAttribute("id","global");
      let iconStyle = this.xmlDocument.createElement('IconStyle');
      let lineStyle = this.xmlDocument.createElement('LineStyle');

      let balloonStyle = this.xmlDocument.createElement('BalloonStyle');
      let text = this.xmlDocument.createElement('text');
      text.innerHTML="<h2>$[nameDevice]</h2><br/><b>ID: </b>$[idDevice]<br/><b>Fecha/Hora: </b>$[dateTime]<br/><b>Velocidad: </b>$[speed]<br/>";
      balloonStyle.appendChild(text);
      style.appendChild(balloonStyle);

      let styleLine = this.xmlDocument.createElement('Style');
      styleLine.setAttribute("id","route");
      let line = this.xmlDocument.createElement('LineStyle');
      let color = this.xmlDocument.createElement('color');
      color.innerHTML = "FF0000FF";
      let widthLine = this.xmlDocument.createElement('width');
      widthLine.innerHTML = "4";
      line.appendChild(color);
      line.appendChild(widthLine);
      styleLine.appendChild(line);

      let iconParked = this.xmlDocument.createElement('Icon');
      let hrefParked = this.xmlDocument.createElement('href');
      hrefParked.innerHTML = "http://maps.google.com/mapfiles/kml/paddle/P.png";
      iconParked.appendChild(hrefParked);
      iconParkedStyle.appendChild(iconParked);

      let icon = this.xmlDocument.createElement('Icon');
      let href = this.xmlDocument.createElement('href');
      href.innerHTML = "http://maps.google.com/mapfiles/kml/shapes/track.png";
      icon.appendChild(href);
      iconStyle.appendChild(icon);

      let width = this.xmlDocument.createElement('width');
      width.innerHTML = "2";

      lineStyle.appendChild(width);
      style.appendChild(iconStyle);
      style.appendChild(lineStyle);

      styleParked.appendChild(iconParkedStyle);

      documentNode.appendChild(style);
      documentNode.appendChild(styleParked);
      documentNode.appendChild(styleLine);
      let coordinatesString  = "";
      positions.forEach((coord, i) => {
        coordinatesString += coord.longitude+","+coord.latitude+","+coord.altitude+"\n";
        documentNode.appendChild(this.createPointNode(i, coord));
      });

      let placemarkLine = this.xmlDocument.createElement('Placemark');
      let lineString = this.xmlDocument.createElement('LineString');
      let coordinates = this.xmlDocument.createElement('coordinates');
      coordinates.innerHTML = coordinatesString;

      let styleUrl = this.xmlDocument.createElement('styleUrl');
      styleUrl.innerHTML = "#route";

      let extrude = this.xmlDocument.createElement('extrude');
      extrude.innerHTML = "1";
      let tessellate = this.xmlDocument.createElement('tessellate');
      tessellate.innerHTML = "1";
      let altitudeMode = this.xmlDocument.createElement('altitudeMode');
      altitudeMode.innerHTML = "absoluto";

      lineString.appendChild(extrude);
      lineString.appendChild(tessellate);
      lineString.appendChild(altitudeMode);
      lineString.appendChild(coordinates);
      placemarkLine.appendChild(styleUrl);
      placemarkLine.appendChild(lineString);
      documentNode.appendChild(placemarkLine);

      parkedPositions.forEach((coord, i) => {
        documentNode.appendChild(this.createParkedNode(i, coord));
      });

      return this.xmlDocumentToString(this.xmlDocument);
    }

    xmlDocumentToString(xmlDocument: XMLDocument): string {
      let textXML = new XMLSerializer().serializeToString(this.xmlDocument);
      textXML = '<?xml version="1.0" encoding="UTF-8"?>' + textXML;
      return textXML;
    }

    createParkedNode(name,position:any): HTMLElement {
      let placemarkNode = this.xmlDocument.createElement('Placemark');
      let nameNode = this.xmlDocument.createElement('name');
      nameNode.innerHTML = "P"+name +" - "+position.deviceTime;

      let extendedData = this.xmlDocument.createElement('ExtendedData');
      let idDevice = this.xmlDocument.createElement('Data');
      idDevice.setAttribute("name","idDevice");
      let valueIdDevice = this.xmlDocument.createElement('value');
      valueIdDevice.innerHTML=position.idDevice;
      idDevice.appendChild(valueIdDevice);
      extendedData.appendChild(idDevice);

      let dateTime = this.xmlDocument.createElement('Data');
      dateTime.setAttribute("name","dateTime");
      let valueDateTime = this.xmlDocument.createElement('value');
      valueDateTime.innerHTML=position.deviceTime;
      dateTime.appendChild(valueDateTime);
      extendedData.appendChild(dateTime);

      let duration = this.xmlDocument.createElement('Data');
      duration.setAttribute("name","duration");
      let valueDuration = this.xmlDocument.createElement('value');
      valueDuration.innerHTML=position.duration;
      duration.appendChild(valueDuration);
      extendedData.appendChild(duration);

      let nameDevice = this.xmlDocument.createElement('Data');
      nameDevice.setAttribute("name","nameDevice");
      let valueNameDevice = this.xmlDocument.createElement('value');
      valueNameDevice.innerHTML=position.nameDevice;
      nameDevice.appendChild(valueNameDevice);
      extendedData.appendChild(nameDevice);

      let from = this.xmlDocument.createElement('Data');
      from.setAttribute("name","from");
      let valueFrom = this.xmlDocument.createElement('value');
      valueFrom.innerHTML=position.from;
      from.appendChild(valueFrom);
      extendedData.appendChild(from);

      let to = this.xmlDocument.createElement('Data');
      to.setAttribute("name","to");
      let valueTo = this.xmlDocument.createElement('value');
      valueTo.innerHTML=position.to;
      to.appendChild(valueTo);
      extendedData.appendChild(to);

      let lookAt = this.xmlDocument.createElement('LookAt');
      let longitude = this.xmlDocument.createElement('longitude');
      longitude.innerHTML = position.longitude;
      let latitude = this.xmlDocument.createElement('latitude');
      latitude.innerHTML = position.latitude;
      let altitude = this.xmlDocument.createElement('altitude');
      altitude.innerHTML = position.altitude;
      let heading = this.xmlDocument.createElement('heading');
      heading.innerHTML = position.course;
      let tilt = this.xmlDocument.createElement('tilt');
      tilt.innerHTML = "45";
      let range = this.xmlDocument.createElement('range');
      range.innerHTML = "200";

      lookAt.appendChild(longitude);
      lookAt.appendChild(latitude);
      lookAt.appendChild(altitude);
      lookAt.appendChild(heading);
      lookAt.appendChild(tilt);
      lookAt.appendChild(range);

      let styleUrl = this.xmlDocument.createElement('styleUrl');
      styleUrl.innerHTML = "#parked";

      let pointNode = this.xmlDocument.createElement('Point');
      let coordinatesNode = this.xmlDocument.createElement('coordinates');
      coordinatesNode.innerHTML = position.longitude+","+position.latitude+","+position.altitude;

      placemarkNode.appendChild(nameNode);
      placemarkNode.appendChild(extendedData);
      placemarkNode.appendChild(lookAt);
      placemarkNode.appendChild(styleUrl);
      placemarkNode.appendChild(pointNode);

      pointNode.appendChild(coordinatesNode);
      return placemarkNode;
    }

    createPointNode(name,position:any): HTMLElement {
      let placemarkNode = this.xmlDocument.createElement('Placemark');
      let nameNode = this.xmlDocument.createElement('name');
      nameNode.innerHTML = name +" - "+position.deviceTime;
      //let descriptionNode = this.xmlDocument.createElement('description');
      //descriptionNode.innerHTML = "&lt;h3&gt;"+position.nameDevice+"&lt;/h3&gt;"+
      //"&lt;label style='font-weight: bold;'&gt;ID: &lt;/label&gt;&lt;label&gt;"+position.idDevice+"&lt;/label&gt;";
      let extendedData = this.xmlDocument.createElement('ExtendedData');
      let idDevice = this.xmlDocument.createElement('Data');
      idDevice.setAttribute("name","idDevice");
      let valueIdDevice = this.xmlDocument.createElement('value');
      valueIdDevice.innerHTML=position.idDevice;
      idDevice.appendChild(valueIdDevice);
      extendedData.appendChild(idDevice);

      let dateTime = this.xmlDocument.createElement('Data');
      dateTime.setAttribute("name","dateTime");
      let valueDateTime = this.xmlDocument.createElement('value');
      valueDateTime.innerHTML=position.deviceTime;
      dateTime.appendChild(valueDateTime);
      extendedData.appendChild(dateTime);

      let speed = this.xmlDocument.createElement('Data');
      speed.setAttribute("name","speed");
      let valueSpeed = this.xmlDocument.createElement('value');
      valueSpeed.innerHTML=position.speed.toFixed(2);
      speed.appendChild(valueSpeed);
      extendedData.appendChild(speed);

      let nameDevice = this.xmlDocument.createElement('Data');
      nameDevice.setAttribute("name","nameDevice");
      let valueNameDevice = this.xmlDocument.createElement('value');
      valueNameDevice.innerHTML=position.nameDevice;
      nameDevice.appendChild(valueNameDevice);
      extendedData.appendChild(nameDevice);

      let lookAt = this.xmlDocument.createElement('LookAt');
      let longitude = this.xmlDocument.createElement('longitude');
      longitude.innerHTML = position.longitude;
      let latitude = this.xmlDocument.createElement('latitude');
      latitude.innerHTML = position.latitude;
      let altitude = this.xmlDocument.createElement('altitude');
      altitude.innerHTML = position.altitude;
      let heading = this.xmlDocument.createElement('heading');
      heading.innerHTML = position.course;
      let tilt = this.xmlDocument.createElement('tilt');
      tilt.innerHTML = "45";
      let range = this.xmlDocument.createElement('range');
      range.innerHTML = "200";

      lookAt.appendChild(longitude);
      lookAt.appendChild(latitude);
      lookAt.appendChild(altitude);
      lookAt.appendChild(heading);
      lookAt.appendChild(tilt);
      lookAt.appendChild(range);

      let styleUrl = this.xmlDocument.createElement('styleUrl');
      styleUrl.innerHTML = "#global";

      let pointNode = this.xmlDocument.createElement('Point');
      let coordinatesNode = this.xmlDocument.createElement('coordinates');
      coordinatesNode.innerHTML = position.longitude+","+position.latitude+","+position.altitude;

      placemarkNode.appendChild(nameNode);
      placemarkNode.appendChild(extendedData);
      placemarkNode.appendChild(lookAt);
      placemarkNode.appendChild(styleUrl);
      placemarkNode.appendChild(pointNode);

      pointNode.appendChild(coordinatesNode);
      return placemarkNode;
    }
  }



// WEBPACK FOOTER //
// ./src/app/position-history/position-history.component.ts